import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getHeaderLings } from "./constants";
import styles from './HeaderLinks.module.scss';
import React from 'react';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 768;

export default () => {
  const router = useRouter();
  const currentPathname = router.pathname;
  const headerLinks = getHeaderLings(currentPathname);
  const [mobile, setMobile] = React.useState(false);
  React.useEffect(() => {
    const checkMobile = () => setMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className={styles["header-links"]}>
      {headerLinks.map((linkObj, idx) => {
        if (linkObj.isDropdown && linkObj.children) {
          if (!mobile) {
            // Ant Design Menu for dropdown
            const menu = (
              <Menu>
                {linkObj.children.map((child, cidx) => (
                  <Menu.Item key={cidx} className={child.isActive(currentPathname) ? styles.active : ''}>
                    <a href={child.href}>{child.title}</a>
                  </Menu.Item>
                ))}
              </Menu>
            );
            return (
              <Dropdown overlay={menu} trigger={["hover"]} key={idx} placement="bottomLeft">
                <span className={classNames(styles["link-item"], styles.dropdown, linkObj.isActive(currentPathname) ? styles['header-link-active'] : '')}>
                  {linkObj.title} <DownOutlined style={{ fontSize: 12, marginLeft: 4 }} />
                </span>
              </Dropdown>
            );
          } else {
            // Mobile: render children as flat links
            return linkObj.children.map((child, cidx) => (
              <span key={child.title} className={child.isActive(currentPathname) ? styles['header-link-active link-item'] : styles['link-item']}>
                <a
                  className={classNames(styles["link-item"])}
                  href={child.href}
                >
                  {child.title}
                </a>
              </span>
            ));
          }
        }
        // Not a dropdown
        return (
          <span key={idx} className={classNames(styles["link-item"], linkObj.isActive(currentPathname) && styles['header-link-active'])}>
            {linkObj.href && linkObj.href.startsWith("http") ? (
              <Link
                key={idx}
                className={styles["link-item"]}
                href={linkObj.href}
              >
                <a className={styles["link-item"]}>{linkObj.title}</a>
              </Link>
            ) : (
              <a
                key={idx}
                className={styles["link-item"]}
                href={linkObj.href}
              >
                {linkObj.title}
              </a>
            )}
          </span>
        );
      })}
    </div>
  );
};
